import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { loginFormSelector, userSelector } from 'src/selectors'
import { updateLoginForm } from 'src/actions/login'

import TextInputElement from 'components/forms/TextInputElement'
import cn from 'classnames'
import styles from './full-name-input-inner.scss'
import { containsURL } from 'src/services/url_validation'

const FullNameInputInner = props => {
  const { inline } = props
  const loginForm = useSelector(loginFormSelector)
  const user = useSelector(userSelector)

  const dispatch = useDispatch()

  const getNameErrorText = value => {
    if (value && containsURL(value)) return 'No URLs allowed'
    return ''
  }

  const firstNameErrorText = getNameErrorText(loginForm.firstName)
  const lastNameErrorText = getNameErrorText(loginForm.lastName)

  const setFirstName = event => {
    const { value } = event.target
    dispatch(updateLoginForm({ firstName: value }))
  }

  const setLastName = event => {
    const { value } = event.target
    dispatch(updateLoginForm({ lastName: value }))
  }

  useEffect(() => {
    if (user) {
      const { first_name, last_name } = user
      if ((!loginForm.newUserId && first_name !== 'Hobnob User')) {
        dispatch(
          updateLoginForm({
            firstName: first_name,
            lastName: last_name
          })
        )
      }
    }
  }, [user, loginForm.loginInRSVP])

  return (
    <div
      className={cn(
        styles['full-name-inner-container'],
        inline && styles['full-name-inner-container-inline']
      )}
    >
      <div className={styles['input-container']}>
        <div className={styles['input-wrapper']}>
          <TextInputElement
            className={cn(styles['input-inner'], {
              [styles['input-inner-error']]: !!firstNameErrorText
            })}
            placeholder="First Name"
            onChange={setFirstName}
            valid={!firstNameErrorText}
            value={loginForm.firstName}
            maxLength={40}
          />
        </div>
        <div
          className={cn(styles['error-text'], {
            [styles['error-text-hidden']]: !firstNameErrorText
          })}
        >
          {firstNameErrorText}
        </div>
      </div>

      <div className={styles['input-container']}>
        <div className={styles['input-wrapper']}>
          <TextInputElement
            className={cn(styles['input-inner'], {
              [styles['input-inner-error']]: !!lastNameErrorText
            })}
            placeholder="Last Name"
            onChange={setLastName}
            valid={!lastNameErrorText}
            value={loginForm.lastName}
            maxLength={40}
          />
        </div>
        <div
          className={cn(styles['error-text'], {
            [styles['error-text-hidden']]: !lastNameErrorText
          })}
        >
          {lastNameErrorText}
        </div>

      </div>
    </div>
  )
}

FullNameInputInner.propTypes = {
  inline: PropTypes.bool
}

export default FullNameInputInner
